import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactButton, {
  TrueImpactButtonWithLoading,
} from 'shared/design-system/components/TrueImpactButton';
import TrueImpactProgress from 'shared/design-system/components/TrueImpactProgress';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';

interface SubmitCommonComponentProps {
  heading: string;
  subheading: string;
  cancelButtonText?: string;
  buttonText: string;
  isLoading?: boolean;
  errorMessage?: string;
  onClick: () => unknown;
  handleBack: () => unknown;
  className?: string;
}

const StyledDiv = styled.div`
  height: 100%;
  background-color: ${COLORS.whiteBase};
  .top-wrapper {
    text-align: center;
    padding-top: ${SPACERS.extraLarge};
    padding-bottom: ${SPACERS.extraLarge};
    padding-left: ${SPACERS.medium};
    padding-right: ${SPACERS.medium};
    .icon {
      width: 36px;
      height: 36px;
    }
    .progress-text {
      margin-top: ${SPACERS.tiny};
      margin-bottom: ${SPACERS.medium};
    }
    .progress-heading {
      margin-top: ${SPACERS.extraLarge};
      margin-bottom: ${SPACERS.small};
    }
    .progress-bar {
      max-width: 368px;
      margin-left: auto;
      margin-right: auto;
    }
    .progress-content {
      max-width: 478px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: ${SPACERS.extraLarge};
    }
    .button-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: ${SPACERS.medium};
      margin-bottom: ${SPACERS.extraLarge};
    }
    .error-message {
      margin-bottom: ${SPACERS.medium};
    }
  }
`;

const SubmitCommonComponent: React.FC<SubmitCommonComponentProps> = ({
  heading,
  subheading,
  buttonText,
  isLoading,
  errorMessage,
  cancelButtonText = 'Cancel',
  onClick,
  handleBack,
  className,
}) => {
  return (
    <StyledDiv className={className}>
      <div className="top-wrapper">
        <FontAwesomeIcon
          icon={faCheck}
          color={COLORS.success}
          className="icon"
        />
        <TrueImpactText
          variant="heading-label"
          color="blackPure"
          className="progress-text"
        >
          PROGRESS
        </TrueImpactText>
        <TrueImpactProgress
          color="success"
          total={1}
          completed={1}
          className="progress-bar"
        />
        <TrueImpactText
          variant="heading"
          color="blackPure"
          className="progress-heading"
        >
          {heading}
        </TrueImpactText>
        <TrueImpactText className="progress-content">
          {subheading}
        </TrueImpactText>
        {errorMessage && (
          <TrueImpactText
            color="critical"
            className="error-message"
          >
            {errorMessage}
          </TrueImpactText>
        )}
        <div className="button-wrapper">
          <TrueImpactButton
            variant="secondary-large"
            isLoading={isLoading}
            onClick={handleBack}
          >
            {cancelButtonText}
          </TrueImpactButton>
          <TrueImpactButton
            isLoading={isLoading}
            onClick={onClick}
          >
            {buttonText}
          </TrueImpactButton>
        </div>
      </div>
    </StyledDiv>
  );
};

export default SubmitCommonComponent;
